import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { all_routes } from "../feature-module/router/all_routes";
import { isLoginUser } from "../services/user.service";
import { setLogin } from "../core/data/redux/user/userSlice";
import ImageWithBasePath from "../core/data/img/ImageWithBasePath";
import { hideAuthHeaderLoginRoutes } from "../constants/utlis";
import { authHeaderMenuItems, headerMenuItems } from "../constants/mainMenu";
import { Button } from "react-bootstrap";
import LogoutModal from "./logoutModal";

const AuthHeader = () => {
  const routes: any = all_routes;
  const headerRef = useRef(null);
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state: any) => state.user);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  console.log(" auth header page");

  const hideLoginButton = hideAuthHeaderLoginRoutes.includes(location.pathname);

  const showLogOutButton = routes.pricing.includes(location.pathname);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  interface MenuItem {
    label: string;
    path: string;
  }

  useEffect(() => {
    if (isMenuOpen) {
      document.body.classList.add("menu-opened");
      const sidebarOverlay = document.querySelector(".sidebar-overlay");
      if (sidebarOverlay) {
        sidebarOverlay.classList.add("opened");
      }
    } else {
      document.body.classList.remove("menu-opened");
      const sidebarOverlay = document.querySelector(".sidebar-overlay");
      if (sidebarOverlay) {
        sidebarOverlay.classList.remove("opened");
      }
    }

    // Cleanup to remove class if component unmounts
    return () => {
      document.body.classList.remove("menu-opened");
    };
  }, [isMenuOpen]);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/auth/login");
  };

  useEffect(() => {
    const isLogged = isLoginUser();
    if (isLogged) {
      dispatch(setLogin(true));
    } else {
      // navigate(routes.login);
    }
  }, []);

  const handleOpenLogoutModal = () => {
    setShowLogoutModal(true);
  };
  const handleCloseLogoutModal = () => setShowLogoutModal(false);

  return (
    <>
      <header
        ref={headerRef}
        className={
          location.pathname.includes(routes.home)
            ? "header header-trans"
            : "header header-sticky"
        }
      >
        <div className="container-fluid headerInner">
          <nav className="navbar navbar-expand-lg header-nav justify-content-between w-100">
            <div className="d-flex flex-wrap align-items-center">
              <div className="navbar-header">
                {/* <Link to={`/auth/login`} className="navbar-brand logo"> */}
                <div className="navbar-brand logo">
                  {true ? (
                    <ImageWithBasePath
                      src="assets/img/logo.svg"
                      className="img-fluid"
                      alt="Logo"
                    />
                  ) : (
                    <ImageWithBasePath
                      src="assets/img/logo.svg"
                      className="img-fluid"
                      alt="Another Image"
                    />
                  )}
                </div>
                {/* </Link> */}

                <button
                  className="toggleMenu menu-open"
                  id="mobile_btn"
                  onClick={toggleMenu}
                >
                  <ImageWithBasePath
                    src="assets/img/megaMenu.png"
                    className="img-fluid"
                    alt="megaMenu Image"
                  />
                </button>
              </div>

              <div className="main-menu-wrapper">
                <div className="menu-header pb-2 pt-3">
                  {/* <Link to={`/dashboard`} className="menu-logo"> */}
                  <div className="menu-logo">
                    <ImageWithBasePath
                      src="assets/img/logo-light.png"
                      className="img-fluid"
                      alt="Logo"
                    />
                  </div>
                  {/* </Link> */}
                  <Link
                    id="menu_close"
                    className="menu-close"
                    to="#"
                    onClick={toggleMenu}
                  >
                    {" "}
                    <i className="fas fa-times" />
                  </Link>
                </div>

                {/* <ul className="main-nav">
                  {authHeaderMenuItems.map((item, index) => (
                    <li key={index}>
                      <NavLink
                        to={item.path}
                        target="_blank"
                        className={({ isActive }) =>
                          `cursor-pointer mx-1 transition-colors ${isActive ? "bg-black text-white" : "hover:text-blue-600"
                          }`
                        }
                      >
                        {item.label}
                      </NavLink>
                    </li>
                  ))}
                </ul> */}

                <ul className="main-nav">
                  {authHeaderMenuItems.map((item, index) => (
                    <li key={index}>
                      <a
                        href={item.path}
                        target="_blank"
                        rel="noopener noreferrer" // Security!
                        className="cursor-pointer mx-1 transition-colors hover:text-blue-600 px-4 py-2 rounded-md hover:bg-gray-100 inline-block"
                      >
                        {item.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {showLogOutButton && (
              <ul className="nav header-navbar-rht">
                <li className="nav-item gap-3">
                  <Button
                    className="primaryRadiusBtn"
                    onClick={handleOpenLogoutModal}
                  >
                    Log Out
                  </Button>
                </li>
              </ul>
            )}

            {!hideLoginButton && (
              <ul className="nav header-navbar-rht">
                <li className="nav-item gap-3">
                  <Link className="textLink" to={routes.register}>
                    Sign Up
                  </Link>
                  <Link className="primaryRadiusBtn" to={routes.login}>
                    Sign In
                  </Link>
                </li>
              </ul>
            )}
          </nav>
          <div className="sidebar-overlay " onClick={toggleMenu}></div>
        </div>
      </header>

      <LogoutModal show={showLogoutModal} onHide={handleCloseLogoutModal} />
    </>
  );
};

export default AuthHeader;
